import LabelMap from '../../types/label-map/LabelMap';
import __ from '../../i18n';

const TYPE_WATCH = 'WATCH';
const TYPE_STRAP = 'STRAP';
const TYPE_EXTENSION = 'EXTENSION';
const TYPE_OTHER = 'OTHER';

export default new LabelMap([
    [TYPE_WATCH, __('Watch')],
    [TYPE_STRAP, __('Strap')],
    [TYPE_EXTENSION, __('Extension')],
    [TYPE_OTHER, __('Other')],
]);

export {
    TYPE_WATCH,
    TYPE_STRAP,
    TYPE_EXTENSION,
    TYPE_OTHER,
};
